// page: string;
// pageBlockFind: string;
// pageBlockCreateDefault: string;
// pageBlockUpdate: string;
// pageBlockPreview: string;
// pageBlockUpdateInactivate: string;
// pageBlockUpdateActive: string;
// export const permissionsKeys = {
//   page: 'page-config.header-objects',
//   pageBlockUpdate: 'page-config.header-objects.page-version.clonePageVersion', //se esta usando la llave update para no modificar la estructura d ela interfaz, pero podria ser pageBlockClonePageVersion
//   pageBlockPreview: 'page-config.header-objects.page-block.preview',
//   pageBlockUpdateInactivate: 'page-config.header-objects.inactivate.page-block.update',
//   pageBlockUpdateActive: 'page-config.header-objects.active.page-block.update',
//   pageBlockCreateDefault: 'page-config.header-objects.page-block.create.default', //no se usa
//   pageBlockFind: 'page-config.header-objects.page-block.find',
// };

export const permissionsKeys = {
  page: 'page-config.home-page',
  pageBlockFind: 'page-config.home-page.page-block.find',
  pageBlockCreateDefault: 'page-config.home-page.page-block.createDefault',
  pageBlockUpdate: 'page-config.home-page.page-block.update',
  pageBlockPreview: 'page-config.home-page.page-block.preview',
  pageBlockUpdateInactivate: 'page-config.home-page.inactivate.page-block.update',
  pageBlockUpdateActive: 'page-config.home-page.active.page-block.update',
  pageBlockRemove: 'page-config.home-page.page-block.remove',
} as const;
